import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useState, useEffect } from "react";

export function Spinner() {
  const loading = useIsFetching() + useIsMutating() + useIsNavigating();

  return (
    <span style={{ visibility: loading ? "visible" : "hidden" }}>
      <FontAwesomeIcon icon={faGear} spin />
    </span>
  );
}

function useIsNavigating() {
  const router = useRouter();
  const [status, setStatus] = useState(0);

  useEffect(() => {
    const unsub = [
      router.subscribe("onBeforeNavigate", () => setStatus(1)),
      router.subscribe("onResolved", () => setStatus(0)),
    ];

    return () => unsub.forEach((x) => x());
  }, [router]);

  return status;
}
